export default __webpack_public_path__ + "static/media/edit_pencil.0312a67f.svg";